export default __webpack_public_path__ + "static/media/sico_walking_3_radiotelescopes.84d91e2a.jpg";